import { gatewayFetch } from "./rate-limit";
import { refreshAccessTokenOnce } from "./auth-token-refresh";

const REPORT_HITS_PER_PAGE = 30;

class ReportsService {
  static instance = null;

  static getInstance() {
    if (!ReportsService.instance) {
      ReportsService.instance = new ReportsService();
    }
    return ReportsService.instance;
  }

  constructor() {
    this.baseUrl = import.meta.env.VITE_REPORTS_API_BASE_URL || "";
  }

  getHitsPerPage() {
    return REPORT_HITS_PER_PAGE;
  }

  async searchReports({
    query = "*",
    page = 1,
    report = "",
    reportYear = "",
    judgmentYear = "",
    volume = "",
    token = "",
    isAuthenticated = false,
    getAccessToken,
    refreshAccessToken,
    signal,
  }) {
    const request = (accessToken) =>
      gatewayFetch(`${this.baseUrl}/api/reports/search`, {
        method: "POST",
        signal,
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        body: JSON.stringify({
          q: query?.trim() || "*",
          page,
          per_page: REPORT_HITS_PER_PAGE,
          report: report || null,
          report_year: reportYear ? Number(reportYear) : null,
          judgment_year: judgmentYear ? Number(judgmentYear) : null,
          volume: volume || null,
        }),
      });

    let accessToken = token;
    if (isAuthenticated && getAccessToken) {
      accessToken = (await getAccessToken()) || "";
    }

    let response = await request(accessToken);
    if (
      response.status === 401 &&
      isAuthenticated &&
      refreshAccessToken &&
      getAccessToken
    ) {
      await refreshAccessTokenOnce(refreshAccessToken);
      accessToken = (await getAccessToken()) || "";
      response = await request(accessToken);
    }

    if (response.status === 401) {
      throw new Error("AUTH_REQUIRED");
    }

    if (!response.ok) {
      throw new Error(`Failed to load reports: ${response.status}`);
    }

    return response.json();
  }
}

export default ReportsService;
